import { render, staticRenderFns } from "./bodyheader.vue?vue&type=template&id=033af6b2"
import script from "./bodyheader.vue?vue&type=script&lang=js"
export * from "./bodyheader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports